<template>
  <div>
    <el-carousel :interval="500000" height="390px" arrow="always">
      <el-carousel-item v-for="item in noticias" :key="item.Id">
        <el-col :span="24" class="cardContainer">
          <NoticiaCard :noticia="item" />
        </el-col>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  import NoticiaCard from '../Cards/noticiaCard'

  export default {
    name: "HomeNoticias",
    components: { NoticiaCard },
    props: {
      data: { propType: Array, default: [] }
    },

    data() {
      return {
        noticias: this.data
        
      }
    },

    watch: {
      data(newVal) 
      {
        this.noticias = newVal
      }
    }
  }

</script>

<style scoped>

  .cardContainer {
    display: inline-block;
    margin-bottom: 10px;
    margin: 5px 0px;
    padding: 10px;
  }

  @media(min-width: 1600px) 
  {
    .cardContainer > div {
      max-width: 700px;
      margin: 10px auto;
    }
  }

</style>

<style>

  .el-carousel__button {
    width: 15px;
    background-color: var(--main-color);
  }

</style>